import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { MYPAGE_COUPONS, MYPAGE_PAGE, MYPAGE_PASSES, MYPAGE_STORES_PRODUCTS_INDEX } from "@/settings/constant";
import Link from "next/link";
export const utilItems_default = [
    {
        key: "0",
        label: /*#__PURE__*/ _jsx(Link, {
            onClick: ()=>mixpanelEvent("MyClicked", {
                    "Menu Category": "library"
                }),
            href: MYPAGE_PAGE,
            children: "마이쏠북"
        })
    },
    {
        key: "1",
        label: /*#__PURE__*/ _jsx(Link, {
            onClick: ()=>{
                mixpanelEvent("MyClicked", {
                    "Menu Category": "coupons"
                });
                mixpanelEvent("GNB Button Clicked", {
                    "Button Name": "쿠폰 관리"
                });
            },
            href: MYPAGE_COUPONS,
            children: "쿠폰 관리"
        })
    },
    {
        key: "2",
        label: /*#__PURE__*/ _jsx(Link, {
            onClick: ()=>mixpanelEvent("MyClicked", {
                    "Menu Category": "packages"
                }),
            href: MYPAGE_PASSES,
            children: "이용권 관리"
        })
    },
    {
        key: "4",
        label: /*#__PURE__*/ _jsx(Link, {
            onClick: ()=>mixpanelEvent("MyClicked", {
                    "Menu Category": "store"
                }),
            href: MYPAGE_STORES_PRODUCTS_INDEX,
            children: "자료판매"
        })
    },
    // {
    // 	key: '4',
    // 	label: (
    // 		<Link
    // 			onClick={() =>
    // 				mixpanelEvent('MyClicked', {
    // 					'Menu Category': 'account',
    // 				} as MyClickedProperty)
    // 			}
    // 			href={MYPAGE_ACCOUNTS_INDEX_PAGE}>
    // 			계정관리
    // 		</Link>
    // 	),
    // },
    {
        // todo: @button onClick 이벤트로 logout function 호출
        key: "logout",
        label: /*#__PURE__*/ _jsx(Link, {
            href: "/",
            children: "로그아웃"
        })
    }
];
